import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), 'Brightness1Sharp');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/icons/esm/Brightness1Sharp.js
// module id = 1948
// module chunks = 31